"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileLandingZone = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importStar(require("react"));
var react_sortablejs_1 = require("react-sortablejs");
var core_1 = require("@material-ui/core");
var UploadAttachmentsTile_1 = require("../../molecules/UploadAttachmentsTile");
var IconChip_1 = require("../../atoms/IconChip");
var useDownload_1 = require("../../hooks/useDownload");
var styles_1 = __importDefault(require("./styles"));
var Attachments_1 = require("../../utils/Attachments");
/**
 * "Inner" Component for FilesLandingZone
 */
exports.FileLandingZone = react_1.default.memo(function (_a) {
    var idPrefix = _a.idPrefix, _b = _a.existingFiles, existingFiles = _b === void 0 ? [] : _b, acceptedFileTypes = _a.acceptedFileTypes, editable = _a.editable, _c = _a.onChange, onChange = _c === void 0 ? function () { } : _c, _d = _a.onFileClick, onFileClick = _d === void 0 ? function () { } : _d, _e = _a.onFileDropError, onFileDropError = _e === void 0 ? function () { } : _e, selectedFileText = _a.selectedFileText, _f = _a.multipleSelectableFiles, multipleSelectableFiles = _f === void 0 ? false : _f, _g = _a.selectableFiles, selectableFiles = _g === void 0 ? false : _g, _h = _a.draggable, draggable = _h === void 0 ? false : _h, _j = _a.uploadable, uploadable = _j === void 0 ? true : _j, props = __rest(_a, ["idPrefix", "existingFiles", "acceptedFileTypes", "editable", "onChange", "onFileClick", "onFileDropError", "selectedFileText", "multipleSelectableFiles", "selectableFiles", "draggable", "uploadable"]);
    var classes = (0, styles_1.default)();
    var download = (0, useDownload_1.useDownload)().download;
    var _k = (0, react_1.useState)(existingFiles || []), files = _k[0], setFiles = _k[1];
    // handle click, sending the whole object back
    var handleFileClick = (0, react_1.useCallback)(function (index) {
        var file = files[index];
        if (file.original)
            download({
                href: file.originalSrc,
                filename: file.name,
            });
        onFileClick(files[index]);
    }, [download, files, onFileClick]);
    // add files to state
    var handleAddFiles = function (attachedFiles) {
        var fileUpdate = __spreadArray(__spreadArray([], files, true), attachedFiles, true);
        var orderedArray = draggable ? (0, Attachments_1.getOrderedFiles)(fileUpdate) : fileUpdate;
        setFiles(orderedArray);
        onChange({ files: orderedArray, media: [] });
    };
    // handle selection , only accept one element selected at the time
    var handleSelect = (0, react_1.useCallback)(function (index) {
        var copy = __spreadArray([], files, true);
        copy.forEach(function (val, currentIndex) {
            var file = val;
            if (currentIndex === index) {
                file.selectedFile = !file.selectedFile;
            }
            else if (!multipleSelectableFiles)
                file.selectedFile = false;
        });
        setFiles(copy);
    }, [files, multipleSelectableFiles]);
    var handleUpdateFiles = (0, react_1.useCallback)(function (attachedFiles) {
        var orderedArray = draggable
            ? (0, Attachments_1.getOrderedFiles)(attachedFiles)
            : attachedFiles;
        setFiles(orderedArray);
        onChange({ files: orderedArray, media: [] });
    }, [setFiles, onChange, draggable]);
    // remove files/media from state by index
    var handleRemove = (0, react_1.useCallback)(function (index) {
        var copy = __spreadArray([], files, true);
        var file = copy[index];
        if (file.original) {
            // set as removed so we can track for later
            file.removed = true;
        }
        else {
            // otherwise remove any attachment
            copy.splice(index, 1);
        }
        var orderedArray = draggable ? (0, Attachments_1.getOrderedFiles)(copy) : copy;
        setFiles(orderedArray);
        onChange({ files: orderedArray, media: [] });
    }, [files, onChange, draggable]);
    // sugar for different remove actions
    var handleRemoveFile = handleRemove;
    // set size of landing button as it is needed for calcs in swiper wrapper
    var landingButtonSize = "150px";
    var fileChips = (0, react_1.useMemo)(function () { return ((0, jsx_runtime_1.jsx)(react_sortablejs_1.ReactSortable, __assign({ disabled: !editable || !draggable, className: classes.chipContainer, direction: "vertical", list: files, setList: handleUpdateFiles, handle: ".drag-handle" }, { children: files.map(function (file, index) { return ((0, jsx_runtime_1.jsx)(core_1.Box, __assign({ "data-testid": "file-chip", id: "".concat(idPrefix, "FileAttachmentButton"), role: "button", onClick: function () { return !editable && handleFileClick(index); }, className: classes.fileChip, style: { display: "".concat(file.removed ? "none" : "initial") } }, { children: (0, jsx_runtime_1.jsx)(IconChip_1.IconChip, { draggable: draggable, onChange: function () { return editable && handleSelect(index); }, checkable: editable && selectableFiles, checked: file.selectedFile, fileName: file.name, chipText: file.name, fileType: file.type, legendText: selectedFileText, 
                // TODO: where is the onclick!!
                onRemove: function () { return handleRemoveFile(index); }, hideClose: !editable || !uploadable }) }), "File".concat(file.name, "__").concat(index))); }) }))); }, [
        classes.fileChip,
        classes.chipContainer,
        editable,
        uploadable,
        files,
        selectedFileText,
        handleFileClick,
        handleUpdateFiles,
        handleRemoveFile,
        handleSelect,
        idPrefix,
        draggable,
        selectableFiles,
    ]);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(core_1.Box, __assign({ className: classes.root, display: "flex", alignItems: "center" }, props, { children: editable && uploadable && ((0, jsx_runtime_1.jsx)(UploadAttachmentsTile_1.UploadAttachmentsTile, { p: 0, "data-testid": "attachment-tile", idPrefix: idPrefix, acceptedFileTypes: acceptedFileTypes, name: "upload new files", width: landingButtonSize, height: landingButtonSize, flexGrow: 0, flexShrink: 0, onFileDropError: onFileDropError, onChange: function (newFiles) {
                        return handleAddFiles(newFiles);
                    } })) })), Boolean(files.length) && ((0, jsx_runtime_1.jsx)(core_1.Box, __assign({ mt: 2, flexGrow: 1 }, { children: fileChips })))] }));
});
